import { z } from 'zod';

// What Claude did and what Ibraheem decided, as the Activity History shows it. The server builds these from the Serb Mind vault
// (Data/run-log.csv, Data/decisions.csv, Data/draft-edits.csv).

export const ACTIVITY_TYPES = [
  'Rates',
  'Quotation',
  'Shipment',
  'Communication',
  'Financial',
  'Document',
  'Reminder',
  'System',
] as const;
export const LOG_STATUSES = ['Completed', 'Pending Approval', 'Needs Attention'] as const;

export const LogEntrySchema = z.object({
  id: z.string(),
  /** "2026-10-18" (Jordan) */
  date: z.string(),
  /** "10:45" in Jordan time; empty when the vault only records the day */
  time: z.string(),
  by: z.enum(['Claude', 'You']),
  type: z.enum(ACTIVITY_TYPES),
  /** "" for entries that belong to no shipment */
  srb: z.string(),
  /** the customer, agent or carrier it is about */
  related: z.string(),
  relatedKind: z.enum(['Customer', 'Agent', 'Carrier', 'None']),
  activity: z.string(),
  details: z.string(),
  status: z.enum(LOG_STATUSES),
  /** in the detail panel: what Claude did, step by step */
  steps: z.array(z.string()).optional(),
  /** what was recorded */
  info: z.array(z.tuple([z.string(), z.string()])).optional(),
  /** [field, previous, new] */
  changes: z.array(z.tuple([z.string(), z.string(), z.string()])).optional(),
  nextStep: z.string().optional(),
  /** the email this came from, when there is one */
  source: z.string().optional(),
});

export type ActivityType = (typeof ACTIVITY_TYPES)[number];
export type LogStatus = (typeof LOG_STATUSES)[number];
export type LogEntry = z.infer<typeof LogEntrySchema>;
